import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt, faDownload } from '@fortawesome/pro-solid-svg-icons'
import { filter } from 'rxjs/operators'
import { Dispatch, SubmitButton } from './architecture/frontend/index'
import _ from 'lodash'
import Select from 'react-select'
import moment from 'moment'
import DatePicker from 'react-datepicker'

import React, {useCallback} from 'react'
import {useDropzone} from 'react-dropzone'
import loading from '../media/loading.svg'


import "react-datepicker/dist/react-datepicker.css"

const statusBar = (props) => {
  const status = props.shipment?.status
  // Hardcoded with database. Not ideal
  const sentShipmentProcess = props.shipment?.sentShipment ? 0 : 2
  const sortedStatuses = _.sortBy((_.filter(props.statuses, stat => (stat.process === sentShipmentProcess) || stat.slug === 'complete' || stat.slug === 'incomplete') ?? []), status => status.order)
  return (
    <div className='pa2 ba b--moon-gray br2 bg-white f7 fw4 flex flex-wrap' style={{flexShink:0}}>
      {
        sortedStatuses.map(sortStatus => {
          const statusSlug = sortStatus.slug
          return (
            <div className={'pt1 ph1 flex ' + (status === sortStatus.id && ' fw8 evonik-purple ')} style={{flexShink:0}}>
              <div>{sortStatus.name} </div>
              <div className='pl1'>{ statusSlug !== 'complete' && ' >' }</div>
            </div>
          )
        })
      }
      {/* <div className={'ph2 ' + (_.isNil(status) && 'fw7 evonik-light-purple ')}>Incomplete</div>  >  <div className={'ph2 ' + (status === 'submit-referee' && ' fw7 evonik-light-purple ')}>Submit Referee</div>  >  <div className='ph2'>Awaiting Referee</div>  >  <div className='ph2'>Requiring Payment</div>  >  <div className='ph2'>Complete</div> */}
    </div>
  )
}

const fileInput = (props) => {
  const value = props._value
  const id = props.shipment?.id
  return (
    <div className='pa2 w5 flex justify-center'>
      {!_.isNil(value) ?
        <SubmitButton id={'save'} className='' 
        responseId='save'
        defaultChild={ props => (
          <div className='flex items-center'>
            <FontAwesomeIcon onClick={e => Dispatch.nextAction('shipment.refereeDownload', id)} className='f4 pl3 pointer' icon={faDownload} style={{color: '#7bb093'}}/>
            <div className='pt1 pl3 blue fw4 pointer' onClick={e => Dispatch.nextAction('shipment.removeRefereeUpload')}>(remove)</div>
          </div>
        )}
        loadingChild={ props => (
            <div className='mh3 ' style={{width:28}}>
              <img src={loading} alt='loading'/>
            </div>
        )}
        errorChild={ props => (
          <div className='pl3 f7 fw4 red tr pointer'>Error</div>
        )}
        loadingStream={
          Dispatch.getAction('Request.removeRefereeUpload')
          }
        successStream={
          Dispatch.getAction('Response.removeRefereeUpload')
            .pipe(
              filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.upsertShipment) || !_.isNil(e.data.upsertShipment) ))),
            )
          }
        errorStream={
          Dispatch.getAction('Response.removeRefereeUpload')
            .pipe(
              filter(e => !_.isNil(e.errors)),
            )}
      />
        :
        <SubmitButton id={'save'} className='' 
        responseId='save'
        defaultChild={ props => (
          <MyDropzone _id={id}/>
        )}
        loadingChild={ props => (
            <div className='mh3 ' style={{width:28}}>
              <img src={loading} alt='loading'/>
            </div>
        )}
        errorChild={ props => (
          <div className='pl3 f7 fw4 red tr pointer'>Error</div>
        )}
        loadingStream={
          Dispatch.getAction('Request.refereeUpload')
          }
        successStream={
          Dispatch.getAction('Response.refereeUpload')
            .pipe(
              filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.uploadReferee) || !_.isNil(e.data.uploadReferee) ))),
            )
          }
        errorStream={
          Dispatch.getAction('Response.refereeUpload')
            .pipe(
              filter(e => !_.isNil(e.errors)),
            )}
      />
      }
    </div>
  )
}

function MyDropzone(props) {
  const onDrop = useCallback(acceptedFiles => {
    Dispatch.nextAction('shipment.refereeUpload', {file: acceptedFiles[0], id: props._id})
  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop, accept: {"text/*": [".txt", ".pdf"]}})
  return (
    <div className='pointer' {...getRootProps()}>
      <input {...getInputProps()} />
      {
          isDragActive ?
          <FontAwesomeIcon className='f4 ' icon={faFileAlt} style={{color: '#7bb093'}}/> :
            <FontAwesomeIcon className='f4 ' icon={faFileAlt} style={{color: '#7bb093'}}/>
      }
    </div>
  )
}

// class fileInput extends React.Component {
//   onDrop = (acceptedFiles, rejectedFiles) => {
//     Dispatch.nextAction('upload', 'file', acceptedFiles[0])
//   }

//   onLeave = () => {
//     Dispatch.nextState('dragTarget', {})
//     return <div className='h5 bg-near-white f1 gray flex justify-center items-center'> <FontAwesomeIcon icon={faUpload}/> </div>
//   }
//   render() {
//    return (
//      <DropZone onDrop={this.onDrop}>
//        {({getRootProps, getInputProps, isDragActive}) => {
//          return (
//            <div
//              {...getRootProps()}
//            >
//              <input {...getInputProps()} />
//              <div className='h5 bg-near-white f1 gray flex justify-center items-center'> <FontAwesomeIcon icon={faUpload}/> </div>
//              {/* { isDragActive ?
//                 <div className='h5 bg-near-white f1 gray flex justify-center items-center'> <FontAwesomeIcon icon={faUpload}/> </div>
//                  //<p>Drop files here...</p> :
//                 : <div className='h5 bg-near-white f1 gray flex justify-center items-center'> <FontAwesomeIcon icon={faUpload}/> </div>
//              } */}
//            </div>
//          )
//        }}
//      </DropZone>
//    );
//  }
// }


const select = (props) => {
  const value = props._value
  const disabled = props._disabled
  const disabledStyle = disabled ? {pointerEvents: 'none'} : {}
  const disabledClass = disabled ? ' o-30 ' : ''
  const updateType = props._updateType
  const defaultValue = _.find(value, entry => entry.value === props.shipment?.[updateType])
  return (
    <div className={'w5 mt1 ' + disabledClass} style={{...disabledStyle}}>
      <Select options={value} defaultValue={defaultValue} onChange={e=>Dispatch.nextAction('shipment.set', {type: updateType, value: e.value})}/>
    </div>
  )
}

const Text = (props) => {
  const updateType=props._updateType
  const size = props._large ? ' w5 ' : ' w4 '
  return (
    <div className={'mt1' + size}>
     <input 
      className='w-100 pa2 br2 bg-white f7 ba b--moon-gray ' 
      style={{ outline: 'none', borderStyle: 'solid' }} 
      type="text" 
      // name={updateType}
      placeholder=''
      defaultValue={props.shipment?.[updateType]}
      onChange={e=>Dispatch.nextAction('shipment.set', {type: updateType, value: e.target.value})}
    />
    </div>
  )
}

const date = (props) => {
  const value = props.shipment?.[props._updateType] && new Date(props.shipment?.[props._updateType])
  const updateType=props._updateType
  return (
    <div className='w4 mt1 ba b--moon-gray'>
      <DatePicker className='w-100 pa2 bn b--moon-gray input-reset' selected={value} onChange={e => Dispatch.nextAction('shipment.set', {type: updateType, value: moment(e)?.toISOString() ?? ''})} />
    </div>
  )
}

const entryTypes = {
  date: date,
  supplier: (props) => <div className='w5 mt1 ba b--moon-gray pa2 br2 bg-white fw4'>Test</div>,
  remarks: (props) => <div className=' mt1 pa2 ba b--moon-gray br2 bg-white fw4' >Remarks</div>,
  text: Text,
  select: select,
  status: statusBar,
  file: fileInput,
  claimDeniedDate: (props) => <> {props.shipment.claimDeniedDate ? <div className=' ph3 pv2 mb1 bg-light-yellow f7 dark-gray fw6'>Claim Denied on {props.shipment.claimDeniedDate && moment(props.shipment.claimDeniedDate).format('MMMM Do yyyy')}</div> : <div></div> }</>,
  refereedDate: (props) => <> {props.shipment.refereeDate ? <div className=' ph3 pv2 mb1 bg-light-yellow f7 dark-gray fw6'>Sent to Referee on {props.shipment.refereeDate}</div> : <div></div> }</>
}

const EntryItem = (props) => {
  const title = props._title
  const type = props._type
  const Child = entryTypes[type] //props._child
  return (
    <div className='flex items-center fw6 f7'>
      {title && <div className='w4 dark-gray tr'>{title}</div>}
      <div className='pl4'>
        <Child {...props}/>
      </div>
    </div>
  )
}

export default EntryItem